import { IServerItemOption } from 'common/types/fields';

export const DEFAULT_ROTATION_ANGLE_STEP = 22.5;
export const DEFAULT_ROTATION_ANGLE = 0;
export const DEFAULT_ANGLE_OPTION: IServerItemOption = {
  id: '0',
  title: '0',
};
